<script setup lang="ts">
import { MutationTypes } from '@/store/store_types'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'
import ElevatedBlockBtn from '../ui-elements/buttons/ElevatedBlockBtn.vue'
import ElevatedBtn from '../ui-elements/buttons/ElevatedBtn.vue'
import OutlinedBlockBtn from '../ui-elements/buttons/OutlinedBlockBtn.vue'
import OutlinedBtn from '../ui-elements/buttons/OutlinedBtn.vue'
import AlertPopupWindowCopy from './AlertPopupWindow.vue'

const { activator } = defineProps<{ activator: boolean }>()
const emit = defineEmits(['continue', 'close'])
const store = useStore()
function toggleDoNotShowAgain(value: boolean) {
  store.commit(MutationTypes.setDSA_contact_sales_lead_warning, value)
}

const { mobile } = useDisplay()
</script>
<template>
  <AlertPopupWindowCopy
    :activator="activator"
    @close="emit('close')"
    @after-leave="() => {}"
    @do-not-show-again="
      () => {
        toggleDoNotShowAgain(true)
      }
    "
    @show-again="
      () => {
        toggleDoNotShowAgain(false)
      }
    "
  >
    <v-card flat :max-width="mobile ? '100%' : '70%'">
      <v-card-title class="text-center pt-0 pb-8 font-weight-bold">
        {{ mobile ? 'Mark as followed up?' : 'Mark this enquiry as ‘followed up’?' }}
      </v-card-title>
      <v-card-text class="text-md-center">
        Would you like to mark this enquiry as ‘followed up by you’? This will show the rest of your
        team that you have responded to this enquiry and have emailed them.
      </v-card-text>
      <v-card-actions v-if="mobile" class="flex-column align-start justify-center pt-5">
        <ElevatedBlockBtn @click="emit('continue')"> Yes, mark as ‘followed up’ </ElevatedBlockBtn>
        <OutlinedBlockBtn shape="box" @click="emit('close')"> No, don’t mark it </OutlinedBlockBtn>
      </v-card-actions>
      <v-card-actions v-else class="justify-center pt-5">
        <OutlinedBtn @click="emit('close')" class="mr-2"> No, don’t mark it </OutlinedBtn>
        <ElevatedBtn @click="emit('continue')" class="ml-2">
          Yes, mark as ‘followed up’
        </ElevatedBtn>
      </v-card-actions>
    </v-card>
  </AlertPopupWindowCopy>
</template>
